<template>
  <!-- 首页页面 -->
  <div id="sd-see-doctor" v-cloak>
    <header
      ref="header"
      :class="(navTitle !== '' && navTitle !== '首页' && navTitle !== '推荐')?'has-shadow':''"
    >
      <div class="nav-wrapper">
        <div class="logo-text">
          <!-- <img src="../../assets/img/common-img/index-logo.png" alt="" class="logo-img"> -->
          <!-- 新版logo -->
          <img
            src="../../assets/img/videoDetail/shendulogo@2x.png"
            alt=""
            class="logo-img"
            @click="goRouter('/SdSeeDoctor')"
            v-if="navTitle == '' || navTitle == '首页' || navTitle == '推荐'"
          >
          <span
            class="logo-img"
            v-if="navTitle !== '' && navTitle !== '首页' && navTitle !== '推荐'"
          >{{navTitle}}</span>
        </div>
        <!--导航text -->
        <div class="nav-box">
          <ul class="title-nav" ref="moveNav">
            <li
              class="nav-text"
              :class="{ activenav:item.id===navSelectClass}"
              v-for="(item, index) in navData"
              :key="index"
              @click="onNavSubmit(index,item)"
            >
              <p v-if="index == 0">首页</p>
              <p v-if="index !== 0">{{item.title}}</p>
            </li>
          </ul>
        </div>
        <div class="more-icon">
          <!-- <img src="../../assets/img/nav-img/more-normal@2x.png" alt="" @click="goRouter('/SdSeeNav')" class="icon-img"> -->
          <img
            src="../../assets/img/videoDetail/search@2x.png"
            alt=""
            class="icon-img"
            @click="goRouter('SdSearch')"
          >
        </div>
        <!-- end -->
      </div>
      <div class="search-bar">
        <!-- 新版 导航和搜索 换位置 -->
        <!-- <img src="../../assets/img/nav-img/搜索-normal@2x.png" alt="" class="search-icon"> -->
        <img
          src="../../assets/img/videoDetail/department@2x.png"
          alt=""
          @click="goRouter('/SdSeeNav')"
          class="search-icon"
          v-if="navTitle == '' || navTitle == '首页' || navTitle == '推荐'"
        >
        <img
          src="../../assets/img/login-img/3-1档案-返回ic@2x.png"
          alt=""
          @click="goBack"
          class="back-icon"
          v-if="navTitle !== '' && navTitle !== '首页' && navTitle !== '推荐'"
        >
      </div>
    </header>
    <!-- <div class="scroll-wrapper"> -->
    <div class="content-box" :class="{activeContent:!showIndex}" ref="indexScroll">
      <!-- 首页界面 -->
      <div class="change-flag" v-show="showIndex">
        <div
          class="swiper-container"
          :class="swiperNum == 2?'swiper-container2':(swiperNum == 1?'swiper-container1':'')"
          id="swiper"
          v-if="images && swiperNum !== 0"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(image, index) in images"
              :key="index"
              :data-http="image.http"
            >
              <img
                :src="image.link"
                alt=""
                class="slide-img"
                @click="goSwipe(image)"
                :data-http="image.http"
              >
              <span class="total-number" :data-http="image.http">{{image.episode_text}}</span>
              <span class="img-name" :data-http="image.http">{{image.title}}</span>
              <img src="../../assets/img/common-img/pic-bgc.png" alt="" class="shdow-img">
            </div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination"></div>
        </div>
        <div
          class="down-shadow"
          :style="{opacity: shadowOpacity}"
          style="transition: opacity .3s"
          v-if="images"
        >
          <img
            src="../../assets/img/videoDetail/shadow1.png"
            alt=""
            class="down-shadow-img"
            v-if="images.length > 1"
          >
        </div>
        <!-- <img
          src="@/assets/img/see-doctor-icon/shouyebanner.png"
          @click="goRouter('/SdInquiry')"
          style="width: 100%"
          alt=""
        >-->
        <!-- <div>{{testswiper}}</div> -->
        <!-- <div v-for="ii in images" :key="ii.http" @click="gotest(ii.http)" style="border: 1px solid blue">{{ii.http}}</div> -->
        <!-- 新版广告区域 -->
        <!-- <div class="related-video-bg ad-bg">
          <div class="related-video-swiper">
            <ad-dom adWidth="644" adHeight="114" @getChildData="getAdList"></ad-dom>
          </div>
        </div>-->
        <!-- <div class="logo-gif">
              <img src="../../assets/img/askdoctor/banner-GIF.gif" @click="goRouter('SdAskDoctor')" alt="" class="img-gif">
        </div>-->

        <!-- 展示区域 showIndex-->
        <!-- <ul class="area-department" @touchmove="handleTouchMove" v-show="showIndex"> -->
        <!-- 2019年9月25日16:44:59 用回旧需求 -->
        <div class="related-video-bg ad-bg related-video-bg-new1" v-if="!inMiniProgram">
          <div class="related-video-swiper related-video-swiper-new1">
            <img
              class="related-img-new1"
              src="@/assets/img/videoDetail/newad1.png"
              alt=""
              @click="goRouter('/SdInquiry')"
            >
            <img
              class="related-img-new1"
              src="@/assets/img/videoDetail/newad2.png"
              alt=""
              @click="goRouter('/goRegist')"
            >
          </div>
        </div>
        <ul class="area-department" v-show="showIndex">
          <li
            v-for="(item, vIndex) in videoData"
            :key="vIndex"
            :ref="'video-index-' + vIndex"
            class="item-department"
            :style="{zIndex: vIndex == parentItemIndex ? 2 : 1}"
          >
            <div class="item-title">
              <div class="item-nav">
                <!-- <span class="nav-text">{{item.department_name}}</span> -->
                <span
                  class="nav-text"
                  :class="{activeDoctor: !isDoctor.includes(vIndex)}"
                  @click="clickSorts(vIndex)"
                >{{item.title}}</span>
                <span class="nav-flag" v-if="!inMiniProgram">|</span>
                <span
                  class="nav-text"
                  :class="{activeDoctor: isDoctor.includes(vIndex)}"
                  @click="clickDoctor(vIndex)"
                  v-if="!inMiniProgram"
                >名医在线</span>
              </div>
              <img
                v-show="vIndex < videoData.length && !isDoctor.includes(vIndex)"
                src="../../assets/img/groupDetail/watchmore@2x.png"
                alt=""
                @click="goGroup(item,vIndex)"
                class="icon-more"
              >
              <img
                v-show="vIndex < videoData.length && isDoctor.includes(vIndex)"
                src="../../assets/img/groupDetail/watchmore@2x.png"
                alt=""
                @click="goDoctorSearch(item,vIndex)"
                class="icon-more"
              >
            </div>
            <!-- 病症展示 -->
            <!-- 2019年11月28日11:40:24 新版 -->
            <div class="video-wrap2" v-if="!showOldStyle && !isDoctor.includes(vIndex)">
              <div
                class="related-video-2"
                @click="goGroupDetail(item.groupList[0].item_id)"
                v-if="vIndex<showRelate"
              >
                <img alt="" class="related-video-cover" v-lazy="item.groupList[0].image">
                <span class="related-title">{{ item.groupList[0].group_name }}</span>
                <img src="../../assets/img/common-img/pic-bgc.png" alt="" class="shdow-img">
              </div>
              <div class="related-title-bg">
                <span
                  class="related-title"
                  v-for="(_item,_index) in item.groupList"
                  v-if="vIndex<showRelate ? _index !== 0 : true"
                  :key="_index"
                  @click="goGroupDetail(_item.item_id)"
                >{{ _item.group_name }}</span>
              </div>
            </div>
            <!-- 旧版 -->
            <div
              class="video-wrap"
              style="font-size:0"
              v-if="showOldStyle && !isDoctor.includes(vIndex)"
            >
              <div class="related-video-swiper" ref="related-swiper-box">
                <template v-for="(_item, itemIndex) in item.groupList">
                  <div
                    class="video-swiper-item"
                    ref="video-swiper-item"
                    :key="itemIndex"
                    @click="goGroupDetail(_item.item_id)"
                  >
                    <p class="header">
                      <img class="avatur" v-lazy="_item.image">
                      <span class="b_FS-36 c_333 font-medium">{{ _item.group_name }}</span>
                    </p>
                  </div>
                </template>
              </div>
              <div
                v-if="isShowPanel &&  vIndex == parentItemIndex"
                class="video-group-panel"
                :style="{top: flagOffsetY + 'px'}"
                v-clickoutside="handleClickOutSide"
              >
                <p class="arrows-wrap">
                  <i class="arrows" :style="{ left: flagOffsetX + 'px' }"></i>
                </p>
                <div class="wrap">
                  <div class="title">{{ cVideoItem.group_name }}</div>
                  <template v-for="(val,key) in cVideoItem.spjh">
                    <span
                      @click="goVideoDetail(val.item_id)"
                      class="item"
                      :key="key"
                    >{{ val.tag_name.split('-')[1] }}</span>
                  </template>
                  <template v-for="val in leftBlankNum">
                    <span class="item-empty" :key="val"></span>
                  </template>
                </div>
              </div>
            </div>
            <!-- 名医展示 -->
            <ul class="doctor-content" v-if="isDoctor.includes(vIndex)">
              <li
                @click="goDoctor(_item)"
                class="doctor-item"
                v-for="(_item,index) in item.doctorList"
                :key="index"
              >
                <img :src="_item.image" alt="" class="doctor-icon">
                <div class="doctor-icon"></div>
                <div class="doctor-name">
                  <!-- <span class="doctor-flag">{{_item.name}}<span v-if="_item.is_famous_doctor === 'y'" class="name-tips">名医</span></span> -->

                  <span class="doctor-flag">
                    {{_item.name}}
                    <span class="name-tips">
                      <img
                        v-if="_item.is_famous_doctor === 'y'"
                        src="../../assets/img/askdoctor/famous@2x.png"
                        alt=""
                        class="tips-img"
                      >
                    </span>
                  </span>
                </div>
                <span class="doctor-text doctor-level">{{_item.clinic_name}} {{_item.title}}</span>
                <span class="doctor-text">{{_item.hospital}}</span>
              </li>
            </ul>
          </li>
          <div
            class="sos"
            @touchstart="showDeleteButton"
            @touchend="emptyTime"
          >{{showOldStyle==false?'显示旧版':'显示新版'}}</div>
        </ul>
        <!-- end -->
      </div>
      <!-- end -->
      <!-- 分类界面  -->
      <div class="depart-scroll" ref="departScroll">
        <div class="deparament-box" v-show="!showIndex">
          <office-kinds :departmentId="departmentId"></office-kinds>
        </div>
      </div>
      <!-- end -->
      <!-- <div class="bottom-text" v-if="showBottom">
              <span>深读君挑灯夜战正在赶制。。。。</span>
      </div>-->
    </div>
    <!-- </div> -->
    <!-- 视频详情页返回的时候视频会初始化一次，用来装载 -->
    <div id="video-box" v-show="false"></div>
    <app-nav></app-nav>
  </div>
</template>

<script>
  import iMp from "@/common/isMp";
  import SdNav from "../../components/shenduNav/SdNav";
  import OfficeKinds from "../public/OfficeKinds";
  import BScroll from "better-scroll";
  import { Wechat } from "@/common/Wechat";
  import adDom from "@/components/public/Activities";
  import { navList, videoList } from "@/api/index";
  export default {
    components: {
      "app-nav": SdNav,
      "office-kinds": OfficeKinds,
      "ad-dom": adDom
    },
    data() {
      return {
        images: [],
        videoData: [],
        navData: [],
        doctorData: [],
        navSelectClass: 0,
        isDoctor: [],
        departmentId: "",
        showIndex: true,
        showBottom: false,
        departScroll: null,
        indexScroll: null,
        mySwiper: null,
        cVideoGroup: [{}, {}, {}, {}, {}],
        flagOffsetX: 0, // 面板 x 坐标
        flagOffsetY: 0, // 面板 y 坐标
        parentItemIndex: -1, //
        cItemIndex: -1, // 当前聚焦的视频
        cVideoItem: {}, // 视频集合
        isShowPanel: false, // 是否显示详情面板
        scrollTimer: null,
        shadowOpacity: 1,
        swiperNum: 3,
        navTitle: "",
        isGoGroup: false,
        testswiper: "",
        isIphone: false,
        showAd: 0,
        adList: [],
        showRelate: 0, // 当前要显示病种的封面图片的栏目的数量
        showOldStyle: false, // 是否显示旧版
        Loop: null
      };
    },
    mixins: [iMp],
    computed: {
      leftBlankNum() {
        return this.cVideoGroup.length % 4;
      }
    },
    watch: {
      navTitle: {
        handler(newName, oldName) {
          this.navTitle = newName;
        },
        immediate: true
      },
      testswiper(v) {
        // window.location.href = v
      }
    },
    beforeCreate() {},
    created() {
      this.isIphone = /iPhone/i.test(window.navigator.userAgent);
      //this.departmentId = localStorage.getItem('indexDepart')
      this.$nextTick(() => {
        this.getSwipeData();
      });
      this.getVideoData();
      this.$nextTick(() => {
        //this.initScroll()
        this.app.isNoAbsolute = true;
      });
      this.weChatShare();
    },
    beforeMount() {},
    mounted() {},
    activated() {
      this.weChatShare();
      // this.$nextTick(() => {
      // let flag = 1;
      // this.getNavData(flag);
      //   this.departScroll.refresh()
      //   if (this.departScroll) {
      //     this.departScroll.refresh()
      //   }
      //   if (this.mySwiper) {
      //     this.mySwiper.update()
      //   }
      // })
      if (this.navData === "") {
        //this.reload()
      }
    },
    beforeDestroy() {
      // this.isGoGroup = false;
    },
    inject: ["reload", "app"],
    methods: {
      // iphoneX跳转 正则判断参数
      request(str, attribute) {
        var reg = new RegExp("(^|&)" + attribute + "=([^&]*)(&|$)");
        var r = str
          .match(/\?.*/, "?")[0]
          .substr(1)
          .match(reg);
        if (r != null) return decodeURI(r[2].toString());
        return null;
      },
      gotest(v) {
        alert(v);
        window.location.href = v + "&id=" + Math.random();
      },
      // 获取子组件数据
      getAdList(v) {
        this.adList = v.length;
      },
      // goBack() {
      //   if (this.isGoGroup) {
      //     eventBus.$emit("indexDepart", null || "");
      //     eventBus.$emit("navTitle", "推荐" || "");
      //     this.$router.push("/SdSeeDoctor");
      //   } else {
      //     this.goRouter("/SdSeeNav");
      //   }
      //   this.isGoGroup = false;
      //   // this.$router.back(-1)
      // },
      // 跳转到保险
      goLink() {
        window.location.href =
          "http://wxsx.pc.ehuatai.com/weixin/medicalUnion_init.action?cLoginCnm=20004463&productCode=4237";
      },
      weChatShare() {
        const wechat = Wechat.getInstance();
        const data = {
          title: "深读健康", // 分享标题
          desc: "先看视频再问诊，明白一点！深读为你的健康提供专业服务", // 分享描述
          link: "https://wx.shendutv.com/", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://wx.shendutv.com/images/638667815392809725.png" // 分享图标
        };
        wechat.doSomethingAfterWxConfig(this.$http, wechat.weChatShare(data));
      },
      handleClickOutSide(e) {
        if (
          e.target.nodeName == "IMG" &&
          e.target.dataset.index !=
            this.cVideoItem.item_id + "-" + this.cItemIndex
        ) {
          // 重新点开一个
          return;
        }
        this.isShowPanel = false;
        //this.cItemIndex = -1
      },
      computedPosition(e, index, parentId, item) {
        if (this.cItemIndex == index && !this.isShowPanel) {
          this.isShowPanel = false;
          this.cItemIndex = -1;
          return;
        }
        this.cItemIndex = index;
        this.isShowPanel = true;
        let target = e.target;
        let imgTarget = null;
        if (target.nodeName == "IMG") {
          target = target.parentElement.parentElement;
        }
        if (target.nodeName == "P") {
          target = target.parentElement;
        }
        this.cVideoItem = item;
        this.flagOffsetX = target.offsetLeft + target.offsetWidth / 2;
        imgTarget = target.firstElementChild.firstChild;
        this.flagOffsetY = target.offsetTop + imgTarget.offsetHeight;
        if (this.parentItemIndex == parentId) {
          return;
        }
        this.parentItemIndex = parentId;
        this.scrollDeal(parentId);
        //console.log(index, ( Math.floor(index/4) + 1))
      },
      scrollDeal(index) {
        const headerHeight = this.$refs.header.clientHeight;
        if (
          this.$refs["video-index-" + index] &&
          this.$refs["video-index-" + index][0]
        ) {
          const scrollTop = this.$refs["video-index-" + index][0].offsetTop;
          // 兼容 windows 浏览器 document.documentElement.scrollTop
          //document.body.scrollTop = document.documentElement.scrollTop = scrollTop - headerHeight
          this.scrollAnimation(scrollTop - headerHeight);
        }
      },
      scrollAnimation(targetY) {
        // 获取当前位置方法
        // const currentY = document.documentElement.scrollTop || document.body.scrollTop

        // 计算需要移动的距离
        const currentY = this.getScrollTop();
        let needScrollTop = targetY - currentY;
        //console.log(targetY, currentY)
        let _currentY = currentY;
        setTimeout(() => {
          // 一次调用滑动帧数，每次调用会不一样
          const dist = Math.ceil(needScrollTop / 20);
          _currentY += dist;
          if (needScrollTop <= 10 && needScrollTop >= -10) {
            return;
          }
          document.body.scrollTop = document.documentElement.scrollTop = _currentY;
          //window.scrollTo(_currentY, currentY)
          // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
          if (needScrollTop > 20 || needScrollTop < -20) {
            //console.log("scrolling")
            this.scrollAnimation(targetY);
          } else {
            //window.scrollTo(_currentY, targetY)
            //console.log('scrlllend')
            document.body.scrollTop = document.documentElement.scrollTop = _currentY;
          }
        }, 1);
      },
      // 获取滚动条当前的位置
      getScrollTop() {
        // let scrollTop = 0;
        // if (document.documentElement && document.documentElement.scrollTop) {
        // scrollTop = document.documentElement.scrollTop;
        // } else if (document.body) {
        // scrollTop = document.body.scrollTop;
        // }
        // return scrollTop;
        return Math.max(
          document.documentElement.scrollTop,
          document.body.scrollTop
        );
      },
      // 获取轮播数据
      getSwipeData() {
        this.$http.get(navList).then(res => {
          if (res.data.code === "0") {
            this.navData = res.data.data.navs; // 获取nav数据
            let swipeData = res.data.data.slides; // 获取轮播图数据
            swipeData.map((item, index) => {
              let url = {};
              // url.link = 'https://test.shendutv.com' + item.pic_url
              url.link = item.pic_url;
              url.episode_text = item.episode_text;
              url.title = item.title;
              url.http = item.link_url;
              this.images.push(url);
              this.swiperNum = this.images.length < 4 ? this.images.length : 3;
              // this.swiperNum = 1 // 测试
            });
            this.$nextTick(() => {
              this.initSwiper();
            });
          }
        });
      },
      // 初始化轮播
      initSwiper() {
        let self = this;
        // eslint-disable-next-line
        this.mySwiper = new Swiper(".swiper-container", {
          spaceBetween: 29,
          effect: "coverflow",
          centeredSlides: true,
          slidesPerView: self.swiperNum,
          // notNextTick: true,
          loop: true,
          pagination: {
            el: ".swiper-pagination",
            type: "bullets"
          },
          autoplay: {
            delay: 6000,
            disableOnInteraction: false // true时主要用于测试，触碰后停止自动轮播
            // disableOnInteraction: true
          },
          on: {
            touchMove: function(e) {
              // 你的事件
              self.shadowOpacity = 0.5;
            },
            transitionEnd: function(e) {
              self.shadowOpacity = 1;
            },
            tap: function(e) {
              // 没办法了最后一张手牌
              if (self.isIphone) {
                let itemid = self.request(e.srcElement.dataset.http, "itemId");
                self.goGroupDetail(itemid);
              } else {
                // console.log(e)
                // console.log(e.path)
                // console.log(e.srcElement.dataset)
                // window.location.href = e.srcElement.dataset.http;
                // self.testswiper = e.srcElement.dataset.http;
                var goAdr =
                  e.srcElement.dataset.http + "&timestap=" + new Date().getTime();
                self.testswiper = goAdr;
                // alert(1)
                // 兼容ios的跳转
                setTimeout(function() {
                  // window.location.href = goAdr +"&id="+Math.random();
                  window.location.href = goAdr;
                  // window.open(goAdr);
                }, 0);
                // 离开页面时清理定时器
                // self.$once("hook:beforeDestroy", () => {
                //   clearTimeout(iosFix);
                // });
                // console.log(e.srcElement.dataset.http)
              }
            }
          }
        });
      },
      // 获取视频数据
      getVideoData() {
        this.$http.get(videoList).then(res => {
          if (res.data.code == 0) {
            this.videoData = res.data.data;
          }
        });
      },
      onNavSubmit(index, item) {
        this.navSelectClass = item.id;
        this.navTitle = item.title;
        if (index === 0) {
          this.showIndex = true;
          this.departmentId = "";
        } else {
          this.departmentId = item.id;
          this.showIndex = false;
        }
      },
      // 点击分类视频
      goGroup(item, index) {
        // 旧版专题跳转
        // this.isGoGroup = true;
        // eventBus.$emit("indexDepart", item.department_id || "");
        // eventBus.$emit("navTitle", item.title || "");
        // this.navSelectClass = item.department_id;
        // this.departmentId = item.department_id;
        // this.showIndex = false;

        // 新版专题跳转
        this.$router.push({
          path: "/SdSeeGroup",
          query: {
            departmentId: item.department_id || ""
          }
        });
      },
      // 点击名医在线
      clickDoctor(val) {
        let isHad = this.isDoctor.indexOf(val);
        if (isHad > -1) {
          return false;
        } else {
          this.isDoctor.push(val);
        }
      },
      // 去医生详情
      goDoctorSearch(item, index) {
        this.$router.push({
          path: "/SdAskDoctor",
          // query: { department_id: item.department_id, name: item.department_name }
          query: { department_id: item.department_id }
        });
      },
      // 点击科室分类
      clickSorts(val) {
        let isHad = this.isDoctor.indexOf(val);
        if (isHad > -1) {
          this.isDoctor.splice(isHad, 1);
        }
      },
      // 点击图片
      goDetail(item) {
        this.$router.push({
          path: "/SdDetailVideo",
          query: { itemId: item.item_id }
        });
      },
      goGroupDetail(itemId) {
        this.$router.push({
          path: "/SdGroupDetail",
          query: { itemId }
        });
      },
      goVideoDetail(itemId) {
        //return
        this.$router.push("/SdDetailVideo?itemId=" + itemId);
      },
      // // 点击轮播图片跳转(废弃)
      goSwipe(item) {
        //   window.location.href = item.http;
      },
      // 点击搜索框跳转至搜索页
      goRouter(val) {
        this.$router.push(val);
      },
      goSearch(val, query) {
        this.$router.push({ path: val, query: { key: query } });
      },
      // 移动判断
      // handleTouchMove () {
      //   this.showTips()
      // },
      showTips() {
        this.showBottom =
          document.documentElement.scrollTop || document.body.scrollTop > 0;
      },
      goDoctor(val) {
        this.$router.push({
          path: "/SdDoctorMsg",
          query: { doctorId: val.doctor_id }
        });
      },
      // 初始化滚动
      initScroll() {
        // this.indexScroll = new BScroll(this.$refs.indexScroll, {
        //   click: true
        // })
        // this.departScroll = new BScroll(this.$refs.departScroll, {
        //   click: true
        // })
      },
      // 获取导航页传来的参数
      // getNavData(val) {
      //   val++;
      //   // if (val === 1) {
      //   eventBus.$on("indexDepart", val => {
      //     this.departmentId = val || "";
      //     this.navSelectClass = val || 0;
      //     if (this.departmentId === "" || this.departmentId === null) {
      //       this.showIndex = true;
      //     } else {
      //       this.showIndex = false;
      //     }
      //   });
      //   eventBus.$on("navTitle", val => {
      //     this.navTitle = val || "";
      //   });
      // }
      showDeleteButton: function(e) {
        let self = this
        clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(
          function() {
            // alert("长按了");
            self.showOldStyle = !this.showOldStyle
          }.bind(this),
          3000
        );
      },
      emptyTime: function() {
        clearTimeout(this.Loop); //清空定时器，防止重复注册定时器
      }
    }
  };
</script>

<style lang="postcss">
  ::-webkit-scrollbar {
    width: 0;
    height: 0px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }
  #sd-see-doctor {
    user-select: none;
    box-sizing: border-box;
    //overflow: hidden;
    //height: 100%;
    /* touch-action: none; */
    /* position: absolute; */
    padding-bottom: 60px;

    /* 旧版头部 */
    /* & header {
                                      position: relative;
                                      width: 100%;
                                      padding: 48px 30px 20px 30px;
                                      background-color: #2e2e30;
                                      position: fixed;
                                      top: 0;
                                      z-index: 999;
                                      box-sizing: border-box;
                                      overflow: hidden;
                                      & .nav-wrapper {
                                        display: flex;
                                        box-sizing: border-box;
                                      }
                                      & .logo-text {
                                        position: relative;
                                        z-index: 9999;
                                        & .logo-img {
                                          width: 52px;
                                          height: 81px;
                                          position: absolute;
                                          bottom: 2px;
                                          margin-right: 35px;
                                        }
                                      }
                                      & .nav-box {
                                        display: flex;
                                        justify-content: space-between;
                                        overflow: hidden;
                                        position: relative;
                                      }
                                      & .title-nav {
                                        padding: 30px;
                                        padding-left: 0;
                                        margin: -30px;
                                        display: -webkit-box;
                                        overflow-x: scroll;
                                        font-size: 32px;
                                        font-family: Source Han Sans CN;
                                        box-sizing: border-box;
                                        margin-right: 30px;
                                        color: #d0d0d0;
                                        margin-left: 80px;
                                        & li:first-child {
                                          margin-left: 0;
                                        }
                                        & .nav-text {
                                          margin: 0 20px;
                                          height: 50px;
                                          line-height: 60px;
                                        }
                                        & li:first-child {
                                          margin-left: 0;
                                        }
                                        & .activenav {
                                          position: relative;
                                          font-size: 32px;
                                          font-family: SourceHanSansCN-Bold;
                                          font-weight: bold;
                                          color: #37bd19;
                                        }
                                      }
                                      & .title-nav::-webkit-scrollbar {
                                        display: none;
                                      }
                                      & .more-icon {
                                        position: absolute;
                                        right: 10px;
                                        padding: 0 20px;
                                        margin-top: 9px;
                                        & .icon-img {
                                          height: 34px;
                                          margin-top: 1px;
                                        }
                                      }
                                      & .search-bar {
                                        width: 100%;
                                        margin-top: 31px;
                                        position: relative;
                                        display: flex;
                                        background-color: #38383d;
                                        border-radius: 39px !important;
                                        border: none;
                                        & .search-icon {
                                          position: absolute;
                                          width: 38px;
                                          top: 50%;
                                          margin-top: -19px;
                                          left: 30px;
                                        }
                                        & .search-text {
                                          box-sizing: border-box;
                                          background-color: #38383d;
                                          height: 68px;
                                          line-height: normal;
                                          width: 100%;
                                          padding-left: 88px;
                                          font-size: 28px;
                                          color: #999;
                                          border: none;
                                          border-radius: 39px;
                                        }
                                      }
                                    } */

    /* 新版头部 */
    & .has-shadow {
      -webkit-box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
    }
    & header {
      position: relative;
      width: 100%;
      height: 88px;
      /* padding: 48px 30px 20px 30px; */
      padding: 27px 30px;
      background-color: #fffffd;
      position: fixed;
      top: 0;
      z-index: 999;
      box-sizing: border-box;
      overflow: hidden;

      & .nav-wrapper {
        display: flex;
        box-sizing: border-box;
      }
      & .logo-text {
        width: 100%;
        position: relative;
        z-index: 9999;
        & .logo-img {
          min-width: 160px;
          height: 43px;
          line-height: 43px;
          font-size: 34px;
          position: absolute;
          top: -5px;
          left: 50%;
          transform: translateX(-50%);
          text-align: center;
        }
      }
      & .nav-box {
        display: none;
      }
      & .title-nav {
        padding: 30px;
        padding-left: 0;
        margin: -30px;
        display: -webkit-box;
        overflow-x: scroll;
        font-size: 32px;
        font-family: Source Han Sans CN;
        box-sizing: border-box;
        margin-right: 30px;
        color: #d0d0d0;
        margin-left: 80px;
        & li:first-child {
          margin-left: 0;
        }
        & .nav-text {
          margin: 0 20px;
          height: 50px;
          line-height: 60px;
        }
        & li:first-child {
          margin-left: 0;
        }
        & .activenav {
          position: relative;
          font-size: 32px;
          font-family: SourceHanSansCN-Bold;
          font-weight: bold;
          color: #37bd19;
        }
      }
      & .title-nav::-webkit-scrollbar {
        display: none;
      }
      & .more-icon {
        position: absolute;
        /* right: 53px; */
        right: 30px;
        & .icon-img {
          width: 30px;
          height: 30px;
        }
      }
      & .search-bar {
        width: 100%;
        margin-top: 31px;
        position: relative;
        display: flex;
        background-color: #38383d;
        border-radius: 39px !important;
        border: none;
        & .search-icon {
          position: absolute;
          width: 31px;
          top: 50%;
          margin-top: -19px;
          /* left: 30px; */
        }
        & .back-icon {
          position: absolute;
          width: 16px;
          top: -31px;
          /* left: 30px; */
        }
      }
    }

    & .scroll-wrapper {
      /* position: absolute;
                                                            position: relative;
                                                            height: 100px;
                                                            background-color: red;
                                                            width: 100%; */
      /* margin-top: 257px; */
      /* top: 257px; */
    }
    & .content-box {
      /* padding: 0 30px;
                                                             */
      /* padding-top: 243px; */
      box-sizing: border-box;
      background-color: #fffffd;
      /* margin-top: 257px; */
      padding-top: 101px;
      //height: 100%;
      /* height: 90%; */
      /* height: 100px; */
      /* height: 68%; //控制首页滑动距离底部的距离 */
      width: 100%;
      //overflow: auto;
      /* overflow: hidden; */
      position: relative;
      /* position: absolute; */
      /* margin-bottom: 60px; */
      /* padding-bottom: 100px; */
      & .change-flag {
        /* width: 100%; */
        /* padding: 0 30px; */
        overflow: hidden;
      }
      & .depart-scroll {
        //position: absolute;
        //height: 100%;
        /* height: 120%; */
        width: 100%;
        //overflow: hidden;
        /* top: -24px; */
      }
      & .deparament-box {
        // background-color: red;
        width: 100%;
        padding-bottom: 80px;
        top: 30px;
      }
      & .area-department {
        position: relative;
        display: inline-block;
        /* height: 68%; */
        width: 100%;
        padding-bottom: 60px;
        & .item-department {
          position: relative;
          padding-top: 15px;
          /* border-bottom: 1px solid rgba(215, 215, 215, 1); */
          /* padding-bottom: 60px; */
          & .item-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 53px;
            & .item-nav {
              font-size: 32px;
              color: #999;
              /* display: flex;
                                                                    align-items: flex-end; */
            }
            & .nav-flag {
              width: 1px;
              height: 17px;
              margin: 0 40px;
              position: relative;
              top: -3px;
              transform: scaleX(0.5);
            }
            & .icon-more {
              padding: 0 10px;
              width: 28px;
              height: 21px;
              position: relative;
              top: -2px;
            }
            & .nav-text {
              font-size: 32px;
              font-family: "思源雅黑";
            }
            & .activeDoctor {
              font-weight: 700;
              font-family: "SourceHanSansCN-Medium";
              color: #0a090f;
            }
          }
          & .item-content {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            & .item-box {
              // display: inline-block;
              margin-top: 36px;
              width: 49%;
              z-index: 999;
              & .video-wrapper {
                height: 200px;
                width: 100%;
                position: relative;
                display: inline-block;
                border-radius: 10px;
                /* overflow: hidden; */
                & .video-shdow-wrapper {
                  width: 100%;
                  height: 100%;
                  z-index: 1;
                  position: absolute;
                  & .video-shdow {
                    width: 100%;
                    height: 150px;
                    position: absolute;
                    bottom: -24px;
                    z-index: 1;
                  }
                }
                & .shdow-wrapper {
                  width: 100%;
                  overflow: hidden;
                  /* background-color: red; */
                  & .shdow-img {
                    position: absolute;
                    bottom: -25px;
                    height: 30px;
                    width: 100%;
                  }
                }
                & .item-wrapper {
                  /* height: 100%; */
                  width: 45%;
                  width: 100%;
                  overflow: hidden;
                  & .wrapper-img {
                    position: absolute;
                    height: 30px;
                    bottom: 0;
                    width: 100%;
                    overflow: hidden;
                    /* width: 45%; */
                  }
                }
                & .item-img {
                  // display: inline-block;
                  width: 100%;
                  overflow: hidden;
                  border-radius: 10px;
                  height: 200px;
                }
                & .video-num {
                  position: absolute;
                  /* top: 10px; */
                  font-size: 18px;
                  font-family: SourceHanSansCN-Regular;
                  font-weight: 400;
                  color: rgba(255, 255, 255, 1);
                  z-index: 9999;
                  bottom: 10px;
                  right: 10px;
                }
              }
              & .item-name {
                padding-top: 20px;
                color: #333;
                z-index: 999;
                /* background-color: red; */
                & .name-text {
                  z-index: 999;
                  /* height: 35px; */
                  font-size: 30px;
                  width: 300px;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                  line-height: 30px;
                }
              }
              & .item-tips {
                margin-top: 10px;
                & .tips-text {
                  color: #30747a;
                  font-size: 22px;
                  border-radius: 8px;
                  padding: 4px 6px;
                  border: 2px solid #30747a;
                  box-sizing: border-box;
                  display: inline-block;
                }
              }
              & .item-tips span:first-child {
                color: #af5531;
                border: 2px solid #af5531;
                margin-right: 12px;
              }
            }
          }
          & .doctor-content {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 40px;
            /* margin-bottom: -40px; */
            padding: 0 30px;
            & .doctor-item {
              margin-top: 50px;
              margin-bottom: 40px;
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              align-content: center;
              height: 247px;
              text-align: center;
              /* width: 340px; */
              width: 48%;
              border-radius: 10px;
              /* margin: 0 5px */
              /* box-sizing: border-box; */
              box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.08);
              & .doctor-icon {
                width: 120px;
                height: 120px;
                border-radius: 50%;
                display: inline-block;
                /* background-color: red; */
                border: 1px #ccc solid;
                position: absolute;
                margin: auto;
                left: 50%;
                transform: translateX(-50%);
                margin-top: -60px;
              }
              & .doctor-name {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 30px;
                color: #333;
                margin-top: 90px;
                & .doctor-flag {
                  display: inline-block;
                  position: relative;
                }
                & .name-tips {
                  margin-left: 8px;
                  position: absolute;
                  & .tips-img {
                    width: 48px;
                    height: 28px;
                  }
                }
              }
              & .doctor-text {
                margin-top: 20px;
                font-size: 26px;
                color: #666;
              }
              & .doctor-level {
                font-weight: bold;
              }
            }
          }
        }
        & .sos {
          position: absolute;
          z-index: 1;
          right: 0;
          bottom: 60px;
          opacity: 0;
        }
      }
    }
    & .bottom-text {
      font-size: 24px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 80px;
      margin-bottom: 180px;
    }
    & .activeContent {
      padding-top: 90px;
      /* padding-top: 216px; */
      //top: 216px;
      /* position: absolute; */
      /* margin-top: 216px; */
    }
    & .swiper-container {
      width: 200%;
      /* height: 400px; */
      margin-bottom: 50px;
      height: 330px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      /* overflow: visible; */
      /* overflow-x: hidden; */
      /* height: 450px; */
      & .swiper-slide-prev {
        transform: translate3d(-244px, 0px, -600px) rotateX(0deg) rotateY(0deg) !important;
        opacity: 0.5;
      }
      & .swiper-slide-next {
        transform: translate3d(244px, 0px, -600px) rotateX(0deg) rotateY(0deg) !important;
        opacity: 0.5;
      }
      & .swiper-slide {
        width: 100%;
        height: 330px;
        border-radius: 10px;
        /* height: 100%; */
        /* height: 405px; */
        /* height: 450px; */
        text-align: center;
        font-size: 18px;
        background-color: #fffffd;
        position: relative;
        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        border-radius: 10px;
        overflow: visible;
        /* overflow: hidden; */
        /* margin: 0 10px; */
        & .slide-img {
          /* 不要给这个轮播图定高度，不然会出bug，在父级定就行，同时，圆框设置不了不成功，希望接手的你能解决 */
          position: relative;
          top: 0;
          width: 644px !important;
          border-radius: 8px;
          /* overflow: hidden; */
          /* height: 330px !important; */
          /* object-fit: cover; */
        }
        & .total-number {
          position: absolute;
          top: 0px;
          right: -60px;
          color: #fff;
          background-color: #37bd19;
          border-radius: 0 0 6px 6px;
          font-size: 20px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          padding: 8px;
        }
        & .img-name {
          position: absolute;
          bottom: 22px;
          left: -60px;
          font-family: SourceHanSansCN-Bold;
          font-weight: bold;
          font-size: 30px;
          color: #ffffff;
          display: inline-block;
          z-index: 999999;
        }
        & .swiper-slide-shadow-left,
        & .swiper-slide-shadow-right {
          display: none;
        }
      }
      & .swiper-wrapper {
        position: relative;
      }
      & .shdow-img {
        width: 644px;
        height: 110px;
        position: absolute;
        bottom: -20px;
        border-radius: 0 0 11px 11px;
        opacity: 0.5;
        /* z-index: 999; */
        /* background-color: red; */
      }
      & .swiper-pagination {
        position: absolute;
        width: 30%;
        left: 70%;
        margin-bottom: 10px;
        height: 50px;
        z-index: 999;
        /* background-color: red; */
        /* right: 0px !important; */
        bottom: 10px;
        & .swiper-pagination-bullet {
          background-color: #37bd19;
        }
      }
    }
    & .swiper-container2 {
      width: 100%;
      & .swiper-slide {
        & .total-number {
          right: -112.5px;
        }
        & .img-name {
          left: -112.5px;
        }
      }
    }
    & .swiper-container1 {
      width: 100%;
      & .swiper-slide {
        & .total-number {
          right: 75px;
        }
        & .img-name {
          left: 75px;
        }
      }
    }
    & .down-shadow {
      position: absolute;
      top: 310px;
      width: 100%;
      overflow: hidden;
      & .down-shadow-img {
        width: 100%;
        opacity: 0.8;
      }
    }
    & .related-video-bg.ad-bg {
      padding-top: 20px;
      height: 170px;
      overflow-y: hidden;
      background-color: #fffffd;
      & .related-video-swiper {
        white-space: nowrap;
        overflow-x: auto;
        vertical-align: top;
        padding-bottom: 30px;
        /* padding-left: 45px; */
        padding-left: 53px;
        & > div:last-child {
          margin-right: 53px;
        }
        /* 2019年9月25日17:00:16 复古需求 */
        &.related-video-swiper-new1 {
          position: relative;
          height: 170px;
          padding-left: 0;
          & img {
            position: absolute;
            width: 45%;
            &:first-child {
              left: 38px;
            }
            &:last-child {
              right: 38px;
            }
          }
        }
        & .video-swiper-item {
          position: relative;
          vertical-align: top;
          width: 644px;
          height: 114px;
          display: inline-block;
          & .header {
            position: absolute;
            opacity: 0;
            display: flex;
            align-content: center;
            align-items: center;
            width: 100%;
            /* overflow: hidden; */
            border-radius: 10px;
            transition: all 1s;
            & .avatur {
              width: 644px;
              height: 114px;
              object-fit: cover;
              border-radius: 8px;
              box-shadow: 0 14px 20px -10px rgba(80, 82, 88, 0.6);
            }
            & .name {
              font-size: 36px;
              font-family: SourceHanSansCN-Medium;
              color: #333;
            }
          }
          & .showAdcss {
            opacity: 1;
            z-index: 1;
          }
          & ul {
            margin-top: 40px;
            & li:last-child {
              margin-bottom: 0;
            }
          }
          & .relative-video-item {
            display: flex;
            align-content: center;
            align-items: center;
            margin-bottom: 20px;
            & img {
              width: 234px;
              height: 123px;
              margin-right: 20px;
              object-fit: cover;
            }
            & > div {
              & .title {
                font-size: 28px;
                font-family: SourceHanSansCN-Regular;
                font-weight: 400;
                color: #333;
              }
              & .content {
                margin-top: 16px;
                font-size: 24px;
                font-family: SourceHanSansCN-Regular;
                color: #999;
                width: 357px;
                -webkit-box-orient: vertical;
                overflow: hidden;
                line-height: 1;
                text-overflow: ellipsis;
                -webkit-line-clamp: 1;
              }
            }
          }
        }
      }
    }
    & .img-gif {
      width: 100%;
      height: 100px;
      border-radius: 8px;
    }
    & .fade-enter-active,
    & .fade-leave-active {
      transition: opacity 0.1s;
    }
    & .fade-enter,& .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
    /* 2019年11月28日12:19:29 新版 */
    & .video-wrap2 {
      width: 100%;
      position: relative;
      z-index: 10;
      padding: 35px 0 75px;
      background-color: #fffffd;
      & > div {
        margin: 0 52px;
      }
      & .related-video-2 {
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        height: 220px;
        & > img {
          width: 100%;
        }
        & .related-title {
          position: absolute;
          right: 25px;
          bottom: 20px;
          font-size: 30px;
          font-weight: 700;
          color: #fff;
          z-index: 1;
        }
        & .shdow-img {
          position: absolute;
          width: 100%;
          height: 110px;
          left: 0;
          bottom: -20px;
          opacity: 0.5;
        }
      }
      & .related-title-bg {
        margin-top: 10px;
        & > span {
          font-size: 32px;
          font-weight: 300;
          display: inline-block;
          width: 50%;
          margin: 20px 0;
        }
      }
    }
    & .video-wrap {
      width: 100%;
      position: relative;
      z-index: 10;
      margin-top: 35px;
      margin-bottom: 75px;
      height: 280px;
      overflow-y: hidden;
      background-color: #fffffd;
      & .video-group-panel {
        position: absolute;
        width: 100%;

        & .arrows-wrap {
          height: 52px;
          & .arrows {
            transition: all 0.2s;
            transform: translateX(-50%);
            position: absolute;
            top: 14.6px;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 8px 8px 0px 7.5px;
            border-color: #000 transparent transparent transparent;
          }
        }

        & .wrap {
          background-color: #fffffd;
          position: relative;
          font-size: 0;
          width: 690px;
          margin: auto;
          padding: 40px 30px 10px;
          box-sizing: border-box;
          border: 1px solid #d7d7d7;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-content: flex-start;
          flex-direction: row;
          & .title {
            background-color: #fff;
            color: #333;
            font-family: SourceHanSansCN-Medium;
            font-weight: bolder;
            font-size: 24px;
            padding: 0 18px;
            position: absolute;
            left: 14px;
            top: -15px;
          }
          & .item {
            text-align: center;
            padding: 7px 0;
            width: 180px;
            display: inline-block;
            // margin-right: 43px ;
            font-size: 24px;
            color: #666;
            font-family: SourceHanSansCN-Regular;
            border: 1px solid #d7d7d7;
            box-sizing: border-box;
            background-color: #f2f2f2;
            margin-bottom: 20px;
            &.noMargin {
              margin-right: 0;
            }
          }
          & .item-empty {
            width: 180px;
            height: 0;
          }
        }
      }
      & .related-video-swiper {
        white-space: nowrap;
        overflow-x: auto;
        vertical-align: top;
        padding-bottom: 80px;
        & > div:last-child {
          margin-right: 53px;
        }
        & .video-swiper-item {
          vertical-align: top;
          padding-left: 20px;
          height: 100%;
          display: inline-block;
          & .header::after {
            width: 100%;
            height: 100%;
            content: "";
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            background-image: url("../../assets/img/common-img/video-bottom-shdow@2x.png");
            background-position: bottom;
            background-size: 250%;
            background-repeat: no-repeat;
            z-index: 1;
            border-radius: 10px;
          }
          & .header {
            display: flex;
            align-content: center;
            align-items: center;
            width: 100%;
            position: relative;
            position: relative;
            box-shadow: 0 14px 20px -15px rgba(80, 82, 88, 0.6);
            border-radius: 10px;
            & span {
              position: absolute;
              font-size: 26px;
              color: #000;
              bottom: -40px;
              left: 0px;
              z-index: 2;
              font-family: "Helvetica Neue", helvetica, arial, sans-serif;
            }
            & .avatur {
              width: 182px;
              height: 240px;
              object-fit: cover;
              border-radius: 10px;
              /* overflow: hidden; */
              /* box-shadow:0px 0px 50px 0px rgba(80,82,88,1); */
            }
            & .name {
              font-size: 36px;
              font-family: SourceHanSansCN-Medium;
              color: #333;
            }
          }
          & ul {
            margin-top: 40px;
            & li:last-child {
              margin-bottom: 0;
            }
          }
          & .relative-video-item {
            display: flex;
            align-content: center;
            align-items: center;
            margin-bottom: 20px;
            & img {
              width: 234px;
              height: 123px;
              margin-right: 20px;
              object-fit: cover;
            }
            & > div {
              & .title {
                font-size: 28px;
                font-family: SourceHanSansCN-Regular;
                font-weight: 400;
                color: #333;
              }
              & .content {
                margin-top: 16px;
                font-size: 24px;
                font-family: SourceHanSansCN-Regular;
                color: #999;
                width: 357px;
                -webkit-box-orient: vertical;
                overflow: hidden;
                line-height: 1;
                text-overflow: ellipsis;
                -webkit-line-clamp: 1;
              }
            }
          }
        }
        & .video-swiper-item:first-child {
          padding-left: 53px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shenduSeeDoctor/SdSeeDoctor.vue